import React, { useState } from 'react';
import { Box, Link } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import { colors } from '@/styles/ui.theme';

interface Props {
  onClose: () => void;
  href: string;
  primaryText: string;
  leftIcon: React.ReactNode;
}

const DrawerListItem = ({ onClose, href, primaryText, leftIcon }: Props): React.ReactElement => {
  const router = useRouter();
  const [isMouseOver, setMouseOver] = useState(false);
  const isActive = isMouseOver || router.asPath === href;

  return (
    <Link
      onClick={() => {
        router.push(href);
        onClose();
      }}
      onMouseOver={() => setMouseOver(true)}
      onFocus={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      onBlur={() => setMouseOver(false)}
      minW='280px'
      maxH='42px'
      display='flex'
      alignItems='center'
      p='21px 0px 21px 0px'
      textDecoration='none'
      backgroundPosition='center'
      transition='background 0.8s'
      _hover={{
        background: `${colors.descomplica.gray['secondary-gray-10']} radial-gradient(circle, transparent 1%, ${colors.descomplica.gray['secondary-gray-10']} 1%) center/15000%`,
      }}
      _active={{
        backgroundColor: colors.descomplica.gray['secondary-gray-10'],
        backgroundSize: '100%',
        transition: 'background 0s',
      }}
    >
      {isActive && (
        <Box
          position='relative'
          top='0'
          left='0'
          width='4px'
          height='42px'
          backgroundColor={colors.descomplica.green.dark}
        />
      )}
      <Box
        display='flex'
        mr='18px'
        ml={isActive ? '32px' : '36px'}
        color={
          isActive ? colors.descomplica.green.primary : colors.descomplica.gray['secondary-gray-60']
        }
      >
        {leftIcon}
      </Box>
      <Box
        color={
          isActive ? colors.descomplica.green.primary : colors.descomplica.gray['secondary-gray-60']
        }
      >
        {primaryText}
      </Box>
    </Link>
  );
};

export default DrawerListItem;
